import { useEffect, useRef, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ExperienceHighlights } from "./ExperienceHighlights";
import { ExperienceSkills } from "./ExperienceSkills"; // ✅ fixed path

export const ExperienceCard = ({ experience, index }: any) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    }, { threshold: 0.1 });

    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className={`transition-all duration-350 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <Card className="hover:shadow-xl transition-shadow duration-200 ease-out border-2">
        <CardHeader>
          <div className="flex items-start gap-4 mb-3">
            <img
              src={experience.logo}
              alt={`${experience.company} logo`}
              className="w-12 h-12 rounded-lg object-contain bg-white p-1 flex-shrink-0"
            />
            <div className="flex-1">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                <CardTitle className="text-xl">{experience.title}</CardTitle>
                <span className="text-sm text-muted-foreground font-medium">{experience.date}</span>
              </div>
              <CardDescription className="text-base font-bold text-primary mt-1">
                {experience.company}{" "}
                <span className="text-muted-foreground font-normal text-sm">• {experience.location}</span>
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <ExperienceHighlights highlights={experience.highlights} />
          <ExperienceSkills skills={experience.skills} url={experience.url} />
        </CardContent>
      </Card>
    </div>
  );
};
